import Message from './Message.component';
import * as utils from './generateId';

export * from './generateId';

Message.utils = utils;
export default Message;
